import { Box, Button, Group, Modal, Pill, Stack, Text, Tooltip } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconTrash as IconDelete } from '@tabler/icons-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppNotification, useDelete } from '@feature/utils';

import { useRemoveWosResearcherId } from '../model/DashboardQuery';

interface WosResearcherIdPillProps {
  researcherId: string;
}

export function WosResearcherIdPill(props: WosResearcherIdPillProps) {
  const { researcherId } = props;
  const [opened, { open, close }] = useDisclosure(false);
  const { t } = useTranslation();
  const mutation = useRemoveWosResearcherId({ researcherId });
  const { isDeleting, onDelete } = useDelete({ mutation, navigateTo: null });
  const notification = useAppNotification();

  const handleOnClick = useCallback(() => {
    navigator.clipboard
      .writeText(researcherId)
      .then(() => {
        notification.success();
      })
      .catch(err => {
        notification.error(err);
      });
  }, [researcherId, notification]);
  return (
    <Box
      style={{ cursor: 'pointer' }}
      onClick={handleOnClick}
    >
      <Pill
        withRemoveButton
        onRemove={open}
        removeButtonProps={{ 'aria-label': t('wos.removeResearcherId', { researcherId }), 'aria-hidden': false }}
        key={researcherId}
      >
        <Tooltip label={t('tooltip.copyClipboard')}>
          <Text
            span
            size="xs"
          >
            {researcherId}
          </Text>
        </Tooltip>
      </Pill>
      <Modal
        opened={opened}
        onClose={close}
        title={t('profile.removeWosResearcherIdConfirm.title')}
        centered
      >
        <Stack>
          <Text
            style={{ textAlign: 'center' }}
            fw="500"
          >
            {t('profile.removeWosResearcherIdConfirm.content')}
          </Text>
          <Group justify="flex-end">
            <Button
              variant="outline"
              onClick={close}
              loading={isDeleting}
            >
              {t('button.cancel')}
            </Button>
            <Button
              onClick={onDelete}
              bg="red"
              loading={isDeleting}
              leftSection={<IconDelete size={16} />}
            >
              {t('button.delete')}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </Box>
  );
}
